import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { defaults } from './defaults';
import unfetch from 'unfetch';

const httpLink = new HttpLink({
  uri: 'https://pmgraph.reeltime.no/graphql',
  fetch: unfetch
});

let cache = new InMemoryCache();
cache.writeData(defaults);

export const client = new ApolloClient({
  cache,
  link: ApolloLink.from([httpLink])
});
